import { render } from "./CoverFooter.vue?vue&type=template&id=08bfb800"
import script from "./CoverFooter.vue?vue&type=script&lang=js"
export * from "./CoverFooter.vue?vue&type=script&lang=js"

import "./CoverFooter.vue?vue&type=style&index=0&id=08bfb800&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__